// Agreements, packages and kit versions (task 1.10, D-039).
const fieldsEn = {
  type: "Type",
  status: "Status",
  title: "Title",
  company_id: "Organization",
  contact_id: "Person",
  sales_id: "Owner",
  introduced_by_contact_id: "Introduced by",
  signed_at: "Signed on",
  start_date: "Start",
  end_date: "End",
  renewal: "Renewal",
  notice_days: "Notice (days)",
  package_id: "Package",
  contribution_amount: "Contribution (€)",
  kit_version_id: "Kit version",
  kit_shipped_at: "Kit shipped on",
  min_purchase_amount: "Minimum purchase (€)",
  min_purchase_deadline: "Minimum purchase by",
  price_list_id: "Price list",
  commission_rule_id: "Commission rule",
  customer_discount_pct: "Customer discount (%)",
  referrer_reward_pct: "Referrer reward (%)",
  terms: "Terms",
  drive_url: "Drive link",
  obligations: "Obligations",
  free_items: "Free items",
};
const fieldsIt = {
  type: "Tipo",
  status: "Stato",
  title: "Titolo",
  company_id: "Organizzazione",
  contact_id: "Persona",
  sales_id: "Responsabile",
  introduced_by_contact_id: "Segnalato da",
  signed_at: "Firmato il",
  start_date: "Inizio",
  end_date: "Fine",
  renewal: "Rinnovo",
  notice_days: "Preavviso (giorni)",
  package_id: "Pacchetto",
  contribution_amount: "Contributo (€)",
  kit_version_id: "Versione del kit",
  kit_shipped_at: "Kit spedito il",
  min_purchase_amount: "Impegno minimo (€)",
  min_purchase_deadline: "Impegno minimo entro",
  price_list_id: "Listino",
  commission_rule_id: "Regola di commissione",
  customer_discount_pct: "Sconto cliente (%)",
  referrer_reward_pct: "Percentuale segnalatore (%)",
  terms: "Condizioni",
  drive_url: "Link Drive",
  obligations: "Obblighi",
  free_items: "Materiale gratuito",
};

export const tenaxAgreementsEnglishMessages = {
  resources: {
    agreements: {
      name: "Agreement |||| Agreements",
      fields: fieldsEn,
    },
  },
  tenax: {
    agreements: {
      codes: {
        title: "Discount codes",
        copy: "Copy %{code}",
        copied: "%{code} copied",
        copy_failed: "The code could not be copied",
      },
      new: "New agreement",
      edit: "Edit agreement",
      empty: "No agreement yet.",
      saved: "Agreement saved",
      need_party: "An agreement needs an organization or a person.",
      none: "—",
      all: "All",
      open_drive: "Open in Drive",
      open: "Open the agreement",
      first_order: "First order with a code by",
      first_order_hint:
        "Orders arrive in phase 2: until then only the deadline.",
      notice_by: "Notice by %{date}",
      party: { tenax: "Tenax", counterparty: "Counterparty" },
      obligation: "Obligation",
      due_date: "Due",
      done_at: "Done on",
      item: "Item",
      qty: "Qty",
      unit_value: "Value (€)",
      type: {
        coach: "Coach",
        athlete: "Athlete",
        club: "Club",
        partnership: "Partnership",
        agency: "Agency",
        supply: "Supply",
        shareholders: "Shareholders",
        other: "Other",
      },
      status: { draft: "Draft", active: "Active", terminated: "Terminated" },
      renewal: { none: "None", tacit: "Tacit", explicit: "Explicit" },
      warning: {
        over_pool: "Discount and reward over the pool of the rule",
        expiring: "Expiring",
        expired: "Expired",
        first_order_overdue: "First order overdue",
      },
      signals: {
        expiring: "Agreement expiring: %{title}",
        first_order_overdue: "First order overdue: %{title}",
      },
      packages: {
        title: "Packages",
        hint: "Starting values only prefill a new agreement. A package in use is renamed or turned off.",
        new: "New package",
        add: "Add",
        turn_off: "Turn off",
        turn_on: "Turn on",
      },
      kits: {
        title: "Kit versions",
        new: "New kit version",
        add: "Add",
        turn_off: "Turn off",
        turn_on: "Turn on",
      },
    },
  },
};

export const tenaxAgreementsItalianMessages = {
  resources: {
    agreements: {
      name: "Accordo |||| Accordi",
      fields: fieldsIt,
    },
  },
  tenax: {
    agreements: {
      codes: {
        title: "Codici sconto",
        copy: "Copia %{code}",
        copied: "%{code} copiato",
        copy_failed: "Non è stato possibile copiare il codice",
      },
      new: "Nuovo accordo",
      edit: "Modifica accordo",
      empty: "Ancora nessun accordo.",
      saved: "Accordo salvato",
      need_party:
        "Un accordo ha bisogno di un'organizzazione o di una persona.",
      none: "—",
      all: "Tutti",
      open_drive: "Apri in Drive",
      open: "Apri l'accordo",
      first_order: "Primo ordine con codice entro",
      first_order_hint:
        "Gli ordini arrivano nella Fase 2: fino ad allora solo la scadenza.",
      notice_by: "Disdetta entro il %{date}",
      party: { tenax: "Tenax", counterparty: "Controparte" },
      obligation: "Obbligo",
      due_date: "Scadenza",
      done_at: "Fatto il",
      item: "Articolo",
      qty: "Q.tà",
      unit_value: "Valore (€)",
      type: {
        coach: "Maestro",
        athlete: "Atleta",
        club: "Circolo",
        partnership: "Partnership",
        agency: "Agenzia",
        supply: "Fornitura",
        shareholders: "Soci",
        other: "Altro",
      },
      status: { draft: "Bozza", active: "Attivo", terminated: "Terminato" },
      renewal: { none: "Nessuno", tacit: "Tacito", explicit: "Esplicito" },
      warning: {
        over_pool: "Sconto e percentuale oltre il pool della regola",
        expiring: "In scadenza",
        expired: "Scaduto",
        first_order_overdue: "Primo ordine scaduto",
      },
      signals: {
        expiring: "Accordo in scadenza: %{title}",
        first_order_overdue: "Primo ordine scaduto: %{title}",
      },
      packages: {
        title: "Pacchetti",
        hint: "I valori di partenza precompilano solo un accordo nuovo. Un pacchetto usato si rinomina o si disattiva.",
        new: "Nuovo pacchetto",
        add: "Aggiungi",
        turn_off: "Disattiva",
        turn_on: "Riattiva",
      },
      kits: {
        title: "Versioni del kit",
        new: "Nuova versione del kit",
        add: "Aggiungi",
        turn_off: "Disattiva",
        turn_on: "Riattiva",
      },
    },
  },
};
